import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosResponse } from 'axios';
import config from '../config';

const BASE_URL = config.base_url;

const apiClient: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  // withCredentials: true, // Allows sending cookies
  headers: {
    'Content-Type': 'application/json',
    'access-control-allow-origin': '*',
    "ngrok-skip-browser-warning": '*',
  },
});

// Request Interceptor
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('token'); // Example: Fetch token from local storage
    if (token) {
      config.headers.set('Authorization', `Bearer ${token}`);
    }
    return config;
  },
  (error) => {
    throw (error); // Handle request error
  }
);

// Response Interceptor
apiClient.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = process.env.REACT_APP_CHECK_IN_URL || '';
    }
    throw (error?.response?.data);
  }
);

export default apiClient;